import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
  {
    id: 1,
    label: 'Menu',
    isTitle: true,
  },
  {
    id: 2,
    label: 'Dashboard',
    icon: 'ri-dashboard-2-line',
    subItems: [
      {
        id: 36,
        label: 'Sales Order',
        link: '/sales-dashboard',
        parentId: 2,
      },
      {
        id: 35,
        label: 'Product Performance',
        link: '/product-dashboard',
        parentId: 2,
      },
      {
        id: 3,
        label: 'Reports',
        link: '/reports',
        parentId: 2,
      },
      {
        id: 333,
        label: 'Salon Reports',
        link: '/reports/salon-reports',
        parentId: 2,
      },
      {
        id: 334,
        label: 'Purchase Reports',
        link: '/reports/purchase-reports',
        parentId: 2,
      },
      {
        id: 335,
        label: 'Inventory Reports',
        link: '/reports/inventory-reports',
        parentId: 2,
      },
      {
        id: 335,
        label: 'Order Processing Report',
        link: '/reports/order-processing-report',
        parentId: 2,
      },
      {
        id: 335,
        label: 'Dormat Reports',
        link: '/reports/dormat-reports',
        parentId: 2,
      },
      {
        id: 335,
        label: 'Brand Reports',
        link: '/reports/brands-reports',
        parentId: 2,
      },
      {
        id: 335,
        label: 'Sales Agent Reports',
        link: '/reports/sales-agent-reports',
        parentId: 2,
      },
      {
        id: 335,
        label: 'DUE Report',
        link: '/reports/due-reports',
        parentId: 2,
      },
      {
        id: 336,
        label: 'Expiry Date Reports',
        link: '/reports/expiry-date-reports',
        parentId: 2,
      },
      {
        id: 337,
        label: 'Lost Revenue Reports',
        link: '/reports/lost-revenue-reports',
        parentId: 2,
      },
      {
        id: 338,
        label: 'Vendor Payables Reports',
        link: '/reports/vendor-payables-reports',
        parentId: 2,
      },
    ],
  },
  {
    id: 4,
    label: 'UAM',
    icon: 'bx bxs-user-circle',
    subItems: [
      {
        id: 5,
        label: 'Group',
        parentId: 4,
        link: '/users/grouplisting',
      },
      {
        id: 50,
        label: 'Role',
        parentId: 4,
        link: '/users/role',
      },
      {
        id: 6,
        label: 'User',
        parentId: 4,
        link: 'users/userlisting',
      },
      {
        id: 7,
        label: 'Audit History',
        parentId: 4,
        link: 'users/audit-history',
      },
    ],
  },
  // {
  //   id: 7,
  //   label: 'Merchant',
  //   icon: 'bx bxs-school',
  //   subItems: [
  //     {
  //       id: 8,
  //       label: 'Merchant Onboarding',
  //       parentId: 7,
  //       link: '/merchant/merchant-onboarding',
  //     },
  //     {
  //       id: 9,
  //       label: 'Shop Onboarding',
  //       parentId: 7,
  //       link: '/merchant/shop-onboarding',
  //     }
  //   ]
  // },
  {
    id: 413,
    label: 'AI Content',
    icon: 'bx bx-atom',
    link: '/ai-content',
    badge: { text: 'NEW', variant: ' theme-color-badge' },
  },

  {
    id: 41,
    label: 'Brand',
    parentId: 10,
    icon: 'bx bxl-squarespace',
    link: '/product/brand',
  },
  {
    id: 47,
    label: 'Accounts',
    icon: ' ri-tools-fill',
    subItems: [
      {
        id: 48,
        label: 'Sales Recon',
        parentId: 47,
        link: '/accounts/sales-recon',
      },
      {
        id: 498,
        label: 'Purchase Recon',
        parentId: 47,
        link: '/accounts/purchase-recon',
      },
      {
        id: 448,
        label: 'DTDC Recon',
        parentId: 47,
        link: '/accounts/dtdc-recon',
      }
    ],
    },
  {
    id: 10,
    label: 'Product Listing',
    icon: 'bx bxs-shopping-bags',
    // link: '/students/studentlisting',
    subItems: [
      {
        id: 12,
        label: 'Collection',
        parentId: 10,
        link: '/product/collection',
      },
      {
        id: 11,
        label: 'Products',
        parentId: 10,
        link: '/product/',
      },
      {
        id: 14,
        label: 'Product Groups',
        parentId: 10,
        link: '/product/product-groups',
      },
      {
        id: 15,
        label: 'Bundling',
        parentId: 10,
        link: '/product/bundling',
      },
      {
        id: 13,
        label: 'Inventory',
        parentId: 10,
        link: '/product/inventory',
      },
      {
        id: 38,
        label: 'Tag',
        parentId: 10,
        link: '/product/tag',
      },

      // {
      //   id: 34,
      //   label: 'Menu',
      //   icon: 'ri-menu-add-line',
      //   link: '/menu/',
      // },
      // {
      //   id: 37,
      //   label: 'Creative Catalogue',
      //   icon: 'ri-booklet-fill',
      //   link: '/creative-catalogue'
      // },
      {
        id: 45,
        label: 'Catalogue',
        icon: 'ri-booklet-fill',
        link: '/product/catalogue',
      },
      {
        id: 46,
        label: 'Inventory Recon',
        icon: 'ri-booklet-fill',
        link: '/product/inventory-recon',
      },
      {
        id: 447,
        label: 'Stocktaking',
        icon: 'ri-booklet-fill',
        link: '/product/stocktaking',
      },
    ],
  },
  {
    id: 49,
    label: 'Transfers',
    icon: 'bx bx-transfer-alt',
    link: '/transfer',
  },
  {
    id: 42,
    label: 'Salon Listing',
    icon: 'bx bxs-store-alt',
    // link: '/promotion/',
    subItems: [
      {
        id: 43,
        label: 'Salon',
        parentId: 42,
        link: '/salon',
      },
      {
        id: 44,
        label: 'Salon User',
        parentId: 42,
        link: '/salon/user-list',
      },
      {
        id: 27,
        label: 'Salon Group',
        parentId: 17,
        link: '/customer/group',
      },
      {
        id: 83,
        label: 'Salon QNA',
        parentId: 42,
        link: '/salon/salon-qna',
      },
      {
        id: 833,
        label: 'Shop Ledger',
        parentId: 42,
        link: '/salon/shop-ledger',
      }
    ],
  },
  {
    id: 46,
    label: 'POS',
    icon: 'bx bxs-store-alt',
    link: '/pos',
  },
  {
    id: 40,
    label: 'Approval',
    icon: 'bx bx-directions',
    link: '/approval',
  },
  {
    id: 14,
    label: 'Offer & Promotion',
    icon: 'bx bxs-offer',
    // link: '/promotion/',
    subItems: [
      {
        id: 36,
        label: 'Offer',
        parentId: 14,
        link: '/offers',
      },
      {
        id: 37,
        label: 'Promotion',
        parentId: 14,
        link: '/promotion',
      },
    ],
  },
  {
    id: 59,
    label: 'RFQ',
    icon: 'bx bx-file',
    link: '/rfq/',
  },
  {
    id: 55,
    label: 'Performa Invoice',
    icon: 'bx bx-file',
    link: '/performa-invoice/',
  },
  {
    id: 15,
    label: 'Order',
    icon: 'bx bxs-truck',
    link: '/order/',
  },

  {
    id: 55,
    label: 'Invoice',
    icon: 'bx bxs-news',
    subItems:[
      {
        id: 551,
        label: 'Invoice View',
        icon: 'bx bxs-news',
        link: '/invoice/list',
      },
      {
        id: 552,
        label: 'Invoice For Accounting',
        icon: 'bx bxs-news',
        link: '/invoice/',
      },
    ]
  },

  {
    id: 50,
    label: 'CMS',
    icon: 'bx bx-shopping-bag',
    subItems: [
      {
        id: 51,
        label: 'Page Builder',
        parentId: 50,
        link: 'cms/add-page-builder',
      },
      {
        id: 52,
        label: 'Content Management',
        icon: 'bx bxs-calendar-event',
        link: 'cms/content',
        parentId: 50,
      },
    ],
  },
  // {
  //   id: 17,
  //   label: 'Customers',
  //   icon: 'bx bxs-user-detail',
  //   // link: '/customer/',
  //   subItems: [
  //     {
  //       id: 26,
  //       label: 'Customer',
  //       parentId: 17,
  //       link: '/customer'
  //     },
  //     {
  //       id: 27,
  //       label: 'Customer Group',
  //       parentId: 17,
  //       link: '/customer/group'
  //     }
  //   ]
  // },
  {
    id: 33,
    label: 'Marketing',
    icon: 'bx bx-shopping-bag',
    subItems: [
      {
        id: 211,
        label: 'Leads',
        parentId: 20,
        link: '/marketing/leads',
      },
      {
        id: 21,
        label: 'SM Template',
        parentId: 20,
        link: '/marketing/sm-template',
      },
      {
        id: 21,
        label: 'Whatsapp Campaign',
        parentId: 20,
        link: '/marketing',
      },
      {
        id: 25,
        label: 'Event',
        icon: 'bx bxs-calendar-event',
        link: '/event/',
        parentId: 20,
      },
      {
        id: 25,
        label: 'Performance Marketing',
        link: '/event/',
        parentId: 20,
      },
      {
        id: 25,
        label: 'Announcement',
        link: '/marketing/announcment',
        parentId: 20,
      },
      {
        id: 434,
        label: 'Carts',
        link: '/marketing/carts',
        parentId: 20
      }
    ],
  },
  {
    id: 26,
    label: 'Purchases',
    icon: 'bx bxs-purchase-tag-alt',
    // link: '/students/studentlisting',
    subItems: [
      // {
      //   id: 27,
      //   label: 'Bills',
      //   parentId: 26,
      //   link: '/purchases/bills',
      // },
      {
        id: 28,
        label: 'Vendors',
        parentId: 26,
        link: '/purchases/vendor',
      },
      {
        id: 39,
        label: 'Purchase',
        parentId: 26,
        link: 'purchases/purchase',
      },
      {
        id: 43,
        label: 'Credit',
        parentId: 26,
        link: 'purchases/credit',
      },
      {
        id: 40,
        label: 'Return Purchase',
        parentId: 26,
        link: 'purchases/return-purchase',
      },
      {
        id: 44,
        label: 'Print Barcode',
        parentId: 26,
        link: 'purchases/print-barcode',
      },
    ],
  },
  {
    id: 29,
    label: 'Sales & Payments',
    icon: 'bx bxs-credit-card',
    // link: '/students/studentlisting',
    subItems: [
      {
        id: 30,
        label: 'Estimates',
        parentId: 29,
        link: '/sales-and-payments/estimates',
      },
      {
        id: 31,
        label: 'Invoice',
        parentId: 29,
        link: '/sales-and-payments/invoice/',
      },
      {
        id: 32,
        label: 'Payment',
        parentId: 29,
        link: '/sales-and-payments/payment',
      },
      {
        id: 34,
        label: 'RFQ',
        parentId: 29,
        link: '/order/rfq',
      },
    ],
  },
  // {
  //   id: 24,
  //   label: 'Invoice',
  //   icon: 'bx bxs-user-detail',
  //   link: '/invoice/',
  // },

  {
    id: 16,
    label: 'Configuration',
    icon: 'bx bx-qr',
    link: '/configuration',
  },

  {
    id: 18,
    label: 'Plugin',
    icon: ' bx bxs-extension',
    link: '/plugins/',
  },
  {
    id: 19,
    label: 'Tools',
    icon: ' ri-tools-fill',
    link: '/tools/',
  },
  {
    id: 20,
    label: 'Appearance',
    icon: 'bx bxs-palette',
    // link: '/students/studentlisting',
    subItems: [
      {
        id: 21,
        label: 'Theme',
        parentId: 20,
        link: '/appearance/theams',
      },
      {
        id: 22,
        label: 'Pages',
        parentId: 20,
        link: '/appearance',
      },
      {
        id: 23,
        label: 'Blogs',
        parentId: 20,
        link: '/appearance/blog',
      },
    ],
  },
  {
    id: 33,
    label: 'Transaction',
    icon: 'ri-exchange-funds-line',
    subItems: [
      {
        id: 331,
        label: 'Transaction',
        parentId: 33,
        link: '/transaction',
      },
      {
        id: 332,
        label: 'Warehouse Ledger',
        parentId: 33,
        link: '/transaction/warehouse',
      },
      {
        id: 334,
        label: 'Wallet',
        parentId: 33,
        link: '/transaction/wallet',
      },
    ],
  },
  {
    id: 35,
    label: 'Reviews',
    icon: 'bx bxs-user-detail',
    link: '/reviews',
  },
  {
    id:71,
    label:'Sales Performance',
    icon:'bx bxs-user-detail',
    subItems:[
      {
        id: 711,
        label:'Sales Target',
        parentId: 71,
        link: '/sales/target',
      },
      {
        id: 712,
        label:'Target Tracking',
        parentId: 71,
        link:'/sales/report'
      },
    ]
  },
  {
    id:89,
    label:'Settings',
    icon:'bx bxs-user-detail',
    subItems:[
      {
        id:891,
        label:'Magic Numbers',
        parentId:89,
        link:'/setting/magic-numbers'
      }
    ]
  }
  // {
  //   id: 40,
  //   label: 'Page Builder',
  //   icon: 'ri-smartphone-line',
  //   link: '/mobile-shop'
  // },
];
